import { useState } from 'react';
import useClientConfig from '../common/hooks/clientConfigHook';
import { useAsyncEffect } from '../common/hooks/asyncEffect';

const clientModuleRegistry = {
    aces: () => import('./aces'),
    1300: () => import('./1300'),
    workforce3: () => import('./workforce3')
}

const getModule = name => {
    if (!clientModuleRegistry[name]) {
        throw new Error('Unknown client module ' + name);
    }
    return clientModuleRegistry[name];
}

export const useClientModule = () => {
    const clientConfig = useClientConfig();
    const [module, setModule] = useState({});
    
    useAsyncEffect(async () => {
            if (clientConfig.clientModule) {
                return await (getModule(clientConfig.clientModule)());
            } else {
                return {};
            }
        },
        setModule,
    [clientConfig.clientModule]);

    return module;
}

export const clientModule = async (clientConfig) => {
    if (!clientConfig.clientModule) {
        return {};
    }
    const module = await getModule(clientConfig.clientModule)();
    return module
}